// Idiomas da interface e a troca de idioma, num lugar só: menu da bandeira
// (components/Navbar.js), telas de acesso (AuthLangSwitch) e a tela Meu perfil.
// A escolha fica em localStorage[i18nextLng], que o detector do i18next lê na
// próxima carga (src/i18n.js).

export const IDIOMAS = Object.freeze([
  { code: 'pt', name: 'Português', flag: '/images/flags/pt.png' },
  { code: 'en', name: 'English', flag: '/images/flags/en.png' },
  { code: 'es', name: 'Español', flag: '/images/flags/es.png' },
  { code: 'fr', name: 'Français', flag: '/images/flags/fr.png' },
  { code: 'de', name: 'Deutsch', flag: '/images/flags/de.png' },
  { code: 'it', name: 'Italiano', flag: '/images/flags/it.png' },
  { code: 'zh', name: '中文', flag: '/images/flags/zh.png' }
]);

// 'pt-BR' -> 'pt'; desconhecido -> 'pt'.
export const siglaDoIdioma = (idioma) => {
  const sigla = String(idioma || 'pt').slice(0, 2).toLowerCase();
  return IDIOMAS.some((item) => item.code === sigla) ? sigla : 'pt';
};

export const bandeiraDoIdioma = (idioma) => (
  IDIOMAS.find((item) => item.code === siglaDoIdioma(idioma)) || IDIOMAS[0]
).flag;

export const trocarIdioma = (i18n, idioma) => {
  const sigla = siglaDoIdioma(idioma);
  i18n.changeLanguage(sigla);
  try {
    localStorage.setItem('i18nextLng', sigla);
  } catch (_err) { /* sem storage: vale só nesta página */ }
  return sigla;
};
